module.exports = __webpack_public_path__ + "static/img/95.a59fcf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/95.png
// module id = PgEb
// module chunks = 0